import type { Invoice } from "@/api.types.v2";

export function InvoiceDueDateDisplay({
  invoice,
  className,
  fallback,
}: {
  invoice: Pick<Invoice, "dueDate" | "dueDateOnSend">;
  className?: string;
  fallback?: string;
}) {
  const dueDate = invoice.dueDateOnSend ?? invoice.dueDate;
  if (!dueDate && !fallback) return null;

  const refreshed =
    !!invoice.dueDateOnSend &&
    (!invoice.dueDate || new Date(invoice.dueDate) <= new Date());
  return (
    <p className={className}>
      {refreshed ? "Due if sent today: " : "Due: "}
      {dueDate ? new Date(dueDate).toLocaleDateString() : fallback}
    </p>
  );
}
